module.exports = __webpack_public_path__ + "img/jyfw.8bdae93.png";